module.exports = __webpack_public_path__ + "static/img/totalFundsBg.8608137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/totalFundsBg.png
// module id = wkhS
// module chunks = 0